import "./App.css";
import { Route, Switch, BrowserRouter, Router } from "react-router-dom";
import VBICare from "./components/vbi-care";
import History from "./routes/history";
function App() {
  return (
    <Router history={History}>
      <Switch>
        <Route component={VBICare} path="*" />
      </Switch>
    </Router>
  );
}

export default App;
